<script setup lang="ts">
const props = defineProps({
  align: {
    type: String,
    default: 'center',
  },
  type: {
    type: String,
    default: 'h2',
  },
  leadingText: String,
  text: String,
  size: {
    type: String,
    default: 'lg',
  },
  color: {
    type: String,
    default: 'primary',
  },
  small: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <div
        v-if="leadingText"
        :class="[
        'a-leading-title',
            'text-' + align,
        'text-' + color
        ]"
        v-html="leadingText"
    ></div>
    <component
        :is="type"
        :class="[
        'a-title',
        'text-' + align,
        'text-' + color,
        small ? 'a-title-small' : 'a-title-large',
      ]"
    >
      <slot>
        {{ text }}
      </slot>
    </component>
  </div>
</template>

<style>


</style>
